import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import AssignmentRestrictionModal from '@/components/Form/components/AssignmentRestriction/components/AssignmentRestrictionModal';
import { DEFAULT_ASSIGNMENT_RESTRICTION } from '@/components/Form/components/AssignmentRestriction/consts';
import { AssignmentRestrictionInput } from '@/types/schema';

import { SurveySettingsDialogProps } from '../../types';

const AssignmentRestriction: React.FC<SurveySettingsDialogProps> = (props) => {
  const { t } = useTranslation();
  const { initialSurvey, onClose, onSubmit } = props;

  const assignmentRestriction =
    initialSurvey.assignmentRestriction || DEFAULT_ASSIGNMENT_RESTRICTION;

  const onSettingsSubmit = useCallback(
    (assignmentRestriction: AssignmentRestrictionInput) => {
      onSubmit({ assignmentRestriction });
    },
    [onSubmit],
  );

  return (
    <AssignmentRestrictionModal
      assignmentRestriction={assignmentRestriction}
      contentName={t('Common:ResourceTypeSM.Survey')}
      onClose={onClose}
      onSubmit={onSettingsSubmit}
    />
  );
};

export default AssignmentRestriction;
